module.exports = __webpack_public_path__ + "img/alfie-m14.7b2a6ccc.jpeg";